// Fetch polyfill for IE
// https://github.com/github/fetch
import 'whatwg-fetch';

// Standalone runtime for Regenerator-compiled generator and async functions
import 'regenerator-runtime/runtime';

// String.prototype.startsWith polyfill for IE
// By some reason it is not included with @babel/preset-env
import 'core-js/es/string/starts-with';

// Full polyfill for browsers with no classList support
// Including IE < Edge missing SVGElement.classList (!)
import 'classlist-polyfill';

// Super small Element.matches fix for older browsers
import 'element-matches';

// Element.closest and Element.matches polyfill for IE
// https://caniuse.com/#feat=element-closest
import elementClosestPolyfill from 'element-closest';

elementClosestPolyfill(window);

// For IE polyfill you can use this code provided by Mozilla:
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(() => {
    if (typeof window.CustomEvent === 'function') return;

    function CustomEvent(event, params) {
        const p = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, p.bubbles, p.cancelable, p.detail);
        return evt;
    }
    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();
